import { createFileRoute } from '@tanstack/react-router';
import { SubscriptionCard } from '@/components/campaign';
import { SettingsSubPageHeader } from '@/components/settings';

/**
 * Billing sub-page. Lives at `/app/settings/billing`, which the `/app/settings`
 * entry in the paywall `EXEMPT_PREFIXES` already covers (prefix match) — so a
 * lapsed / paywalled campaign can always reach this page to pay. The billing
 * banners and the paywall overlay link here.
 */
export const Route = createFileRoute('/app/settings/billing')({
  component: BillingSettingsPage,
});

export function BillingSettingsPage() {
  return (
    <div className="max-w-3xl p-6">
      <SettingsSubPageHeader title="Billing" description="Subscription and payment." />

      <div className="space-y-4 mt-6">
        <SubscriptionCard />
      </div>
    </div>
  );
}
